var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3912 14.9521L15.7162 17.5854C15.7995 18.2771 15.0579 18.7604 14.4662 18.4021L10.9745 16.3271C10.5912 16.3271 10.2162 16.3021 9.84955 16.2521C10.4662 15.5271 10.8329 14.6104 10.8329 13.6187C10.8329 11.2521 8.78288 9.33544 6.24955 9.33544C5.28288 9.33544 4.39122 9.61042 3.64955 10.0937C3.62455 9.88542 3.61621 9.67708 3.61621 9.46041C3.61621 5.66874 6.90788 2.59375 10.9745 2.59375C15.0412 2.59375 18.3329 5.66874 18.3329 9.46041C18.3329 11.7104 17.1745 13.7021 15.3912 14.9521Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 13.6192C10.8337 14.6109 10.467 15.5276 9.85033 16.2526C9.02533 17.2526 7.71699 17.8942 6.25033 17.8942L4.07533 19.1859C3.70866 19.4109 3.24199 19.1026 3.29199 18.6776L3.50032 17.0359C2.38366 16.2609 1.66699 15.0192 1.66699 13.6192C1.66699 12.1526 2.45033 10.8609 3.65033 10.0942C4.392 9.61092 5.28366 9.33594 6.25033 9.33594C8.78366 9.33594 10.8337 11.2526 10.8337 13.6192Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.5ce52117741fe0d0bf08d5ffac90e73e.svg";
export { ForwardRef as ReactComponent };